import clsx from "clsx";
import { Col, ModalProps, useModal } from "@commonlibs";
import { createModal } from "@commonlibs";
import Modal from "ui/common/components/feedback/Modal/Modal";
import ModalFooter from "ui/common/components/feedback/Modal/ModalFooter/ModalFooter";
import useTranslate from "ui/locale/hooks/useTranslate";
import PartnerAutocomplete from "ui/partner/container/PartnerAutocomplete/PartnerAutocomplete";
import { useEffect, useState } from "react";
import type { PartnerDto } from "common/models/api/models/PartnerDto";
import useExportGiftCardStock from "features/giftcards/hooks/useExportGiftCardStock";
import { useQueryClient } from "react-query";
import { Queries } from "ui/query/queries";

export const ExportGiftCardsStockModal = createModal<ModalProps>(({ className, ...rest }) => {
    const translate = useTranslate();
    const { hideModal } = useModal();
    const queryClient = useQueryClient();

    const [partner, setPartner] = useState<PartnerDto>();

    const { mutate, isLoading } = useExportGiftCardStock({ onSettled: handleOnSettled });

    useEffect(() => {
        queryClient.invalidateQueries(Queries.PARTNER_FIND_ALL_WITHOUT_PARENT);
    }, [queryClient]);

    function closeModal() {
        hideModal(ExportGiftCardsStockModal.id);
    }

    function handleOnSubmit() {
        if (!partner?.address) return;
        mutate({ partnerAddress: partner.address });
    }

    function handleOnSettled() {
        closeModal();
    }

    return (
        <Modal
            title={translate("exportGiftCardStock")}
            className={clsx("export-gift-cards-modal", className)}
            style={{ width: "550px" }}
            {...rest}
        >
            <Col gap={30}>
                <PartnerAutocomplete
                    label={translate("giftCardPartnerName")}
                    placeholder={translate("giftCardPartnerName")}
                    name="partner"
                    required
                    partnerType="giftcard"
                    value={partner}
                    onChange={(e) => {
                        const partner = e as PartnerDto;
                        setPartner(partner);
                    }}
                />
                <ModalFooter
                    cancelLabel={translate("cancel")}
                    mainLabel={translate("export")}
                    onCancel={closeModal}
                    onSubmit={handleOnSubmit}
                    isLoading={isLoading}
                />
            </Col>
        </Modal>
    );
});
